import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'm17 17-2.18-2.18', key: '1y7dt1' }],
  ['path', { d: 'M9.56 14.44 17 7', key: 'ue8l15' }],
  ['path', { d: 'M9.56 9.56 12 12', key: 'rml9qv' }],
  ['circle', { cx: '8.5', cy: '15.5', r: '1.5', key: '12hfy1' }],
  ['circle', { cx: '8.5', cy: '8.5', r: '1.5', key: 'cn5opk' }],
  ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', key: 'h1oib' }],
];

/**
 * @component @name SquareScissors
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTcgMTctMi4xOC0yLjE4IiAvPgogIDxwYXRoIGQ9Ik05LjU2IDE0LjQ0IDE3IDciIC8+CiAgPHBhdGggZD0iTTkuNTYgOS41NiAxMiAxMiIgLz4KICA8Y2lyY2xlIGN4PSI4LjUiIGN5PSIxNS41IiByPSIxLjUiIC8+CiAgPGNpcmNsZSBjeD0iOC41IiBjeT0iOC41IiByPSIxLjUiIC8+CiAgPHJlY3QgeD0iMyIgeT0iMyIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiByeD0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/square-scissors
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SquareScissors = createLucideIcon('square-scissors', __iconNode);

export default SquareScissors;
